import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';

import { Dashboard } from '../screens/Dashboard';
import Login from '../screens/Login/Login';
import ForgotPassword from '../screens/ForgotPassword/ForgotPassword';
import { Proposal } from '../screens/Proposal';
import { Manage } from '../screens/Manage';
import Reports from '../screens/Reports';
import ResetPassword from '../screens/ResetPassword/ResetPassword';
import { Form, RetentionForm } from '../screens/Signature/Form';
import { TestUnicoPage, CapturePage, ResultPage } from '../screens/TestUnico';
import { UnicoProvider } from '../hooks/UnicoContext';
import Layout from '../components/Layout';
import { useAuth } from '../hooks/auth';

import PrivateRoute from './PrivateRoute';

const CaptureIframeGlobalStyle = createGlobalStyle`
  html, body {
    height: 100% !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    display: block !important;
    font-size: 16px !important;
  }

  #root {
    height: 100% !important;
    width: 100% !important;
    display: block !important;
    font-size: 16px !important;
    max-width: 100% !important;
  }
`;

const CapturePageWithProvider: React.FC = () => (
  <>
    <CaptureIframeGlobalStyle />
    <UnicoProvider>
      <CapturePage />
    </UnicoProvider>
  </>
);

const SignatureLayoutWithProvider: React.FC = () => (
  <UnicoProvider>
    <Outlet />
  </UnicoProvider>
);

const AppLayoutWrapper: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return <Outlet />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

const isNonProdEnv = window.location.hostname.includes('.dev.') || window.location.hostname.includes('.qa.') || window.location.hostname === 'localhost';

const AvailableRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Rota sem layout — renderizada dentro de iframe no simulador (dev/qa only) */}
      {isNonProdEnv && <Route path="/test-unico/capture" element={<CapturePageWithProvider />} />}

      {/* Signature routes with UnicoProvider for Liveness SDK support */}
      <Route element={<SignatureLayoutWithProvider />}>
        <Route path="/signature/:token" element={<Form />} />
        <Route path="/retention-signature/:token" element={<RetentionForm />} />
      </Route>

      {/* Rotas com layout (sidebar + header) */}
      <Route element={<AppLayoutWrapper />}>
        <Route path="/" index element={<Login />} />
        <Route path="/esqueci-minha-senha" element={<ForgotPassword />} />
        <Route path="/redefinir-senha/*" element={<ResetPassword />} />
        <Route path="/dashboard" element={<PrivateRoute component={Dashboard} />} />
        <Route path="/proposal" element={<PrivateRoute component={Proposal} />} />
        <Route path="/manage-proposal" element={<PrivateRoute component={Manage} />} />
        <Route path="/reports" element={<PrivateRoute component={Reports} />} />
        {isNonProdEnv && <Route path="/test-unico" element={<TestUnicoPage />} />}
        {isNonProdEnv && <Route path="/test-unico/result" element={<ResultPage />} />}
      </Route>
    </Routes>
  );
};

export default AvailableRoutes;
